import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import { GatsbyImage } from 'gatsby-plugin-image'

import { GuaranteeContainer, Heading, Subheader, GuaranteeImageContainer, TextBox } from './styles'
import { GUARANTEE_CONSTANTS } from '../Guarantee/constants'

const HomepageGuarantee = () => {
  const { moneyBack } = useStaticQuery(graphql`
    query HomepageGuaranteeQuery {
      moneyBack: file(relativePath: { eq: "homepage/4-months-free-return-badge.png" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
    }
  `)

  return (
    <GuaranteeContainer>
      <GuaranteeImageContainer>
        <GatsbyImage image={moneyBack.childImageSharp.gatsbyImageData} alt="Money back Guarantee" />
      </GuaranteeImageContainer>
      <TextBox>
        <Heading>{GUARANTEE_CONSTANTS.returns}</Heading>
        <Subheader>{GUARANTEE_CONSTANTS.happiness}</Subheader>
      </TextBox>
    </GuaranteeContainer>
  )
}

export default HomepageGuarantee
